import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useModal from '../../hooks/useModal';
import ErrorModal from './error/ErrorModal';

const MODAL_EXPIRATION_TIME = 7000;

const ModalFabric = ({ type, handleClose, error }) => {
  switch (type) {
    case 'authError':
      return <ErrorModal error={error} handleClose={handleClose} />;
    // case 'SuccessRequest':
    //     return <SuccessRequestModal text={error} handleClose={handleClose} />
    // case 'unsupportedFile':
    //     return <AuthModalError error={error} handleClose={handleClose} />
    // case 'info':
    //     return <InfoModal text={error} handleClose={handleClose} />
    default:
      return <></>;
  }
};

const Modal = (props) => {
  const timeIdRef = useRef(null);
  const his = useHistory();
  const [history, setHistory] = useState(his.location.pathname);
  const { shown, type, error, close } = props;
  his.listen((location, action) => {
    if (location.pathname !== history) setHistory(location.pathname);
  });

  useEffect(() => {
    if (shown) {
      //on open
      timeIdRef.current = setTimeout(close, MODAL_EXPIRATION_TIME);
    } else {
      //on close
      if (timeIdRef.current) clearTimeout(timeIdRef.current);
    }
  }, [shown, close]);

  useEffect(() => {
    //on unmount
    return () => {
      clearTimeout(timeIdRef.current);
    };
  }, [close]);

  const { Modal } = useModal(
    'modal flex',
    <ModalFabric type={type} error={error} handleClose={close} />
  );

  return shown ? <Modal /> : null;
};

export default Modal;
